<template>
  <region-form />
</template>

<script>
import RegionForm from '@/components/forms/RegionForm'
export default {
  components: {
    RegionForm
  }
}
</script>
